import React from 'react';
import styles from './ClinicsTable.module.scss';
import _ from "lodash";

import {Link} from "react-router-dom";
import {$t} from "../../helpers/translator";
import api from "../../helpers/api";
import DataTable from "../miscellaneous/DataTable/DataTable";
import DeleteClinic from "./DeleteClinic/DeleteClinic";
import RestoreDeletedClinic from "./RestoreDeletedClinic/RestoreDeletedClinic";
import Tooltip from "../miscellaneous/Tooltip/Tooltip";
import Input from "../miscellaneous/Input/Input";
import WorkingMode from "../miscellaneous/WorkingMode/WorkingMode";
import Timestamp from "../miscellaneous/Timestamp/Timestamp";
import {FaClinicMedical, FaHospital} from "react-icons/fa";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";
import Style from "../PatientsTable/Patients.module.scss";
import HasPermission from '../../helpers/permissions/HasPermission';

class ClinicsTable extends React.Component {
    static defaultProps = {
        header: $t('global.applicators.clinics')
    }

    constructor(props) {
        super(props);

        const filters = props.filters ? props.filters : {};

        this.state = {
            tableLoading: false,
            payload: {
                sort: 'name',
                order: 'asc',
                search: '',
                type: filters.type ? filters.type : '',
                page: 1,
                per_page: 15,
                distributor_id: this.props.distributorId ? this.props.distributorId : '',
                status: this.props.detached && this.props.userType === 5 ? 'deleted' : 'active' //all / attached / detached
            },
            pagination: null,
            clinics: [],
            typeOptions: [
                {value: '', label: 'All'},
                {value: 'chain', label: 'Only Chains'},
                {value: 'clinic', label: 'Only Clinics'},
            ],
            treatment_saved_data: [
                {
                    value: 1,
                    label: $t('global.account.treatmentSettings.staffIdAndPatientId'),
                    explanation: $t('global.account.treatmentSettings.staffIdAndPatientIdExplained')
                },
                {
                    value: 2,
                    label: $t('global.account.treatmentSettings.staffId'),
                    explanation: $t('global.account.treatmentSettings.staffIdExplained')
                },
                {
                    value: 3,
                    label: $t('global.account.treatmentSettings.patientId'),
                    explanation: $t('global.account.treatmentSettings.patientIdExplained')
                },
                {
                    value: 4,
                    label: $t('global.account.treatmentSettings.noAdditionalData'),
                    explanation: $t('global.account.treatmentSettings.noAdditionalDataExplained')
                },
            ]
        };
    }

    async componentDidMount() {
        await this.getClinics();
    }


    getAPIUrl() {
        let payload = {...this.state.payload};
        return `/clinic?sort=${payload.sort}&order=${payload.order}&search=${payload.search}&page=${payload.page}&per_page=${payload.per_page}&distributor_id=${payload.distributor_id}&type=${payload.type}&status=${payload.status}`;
    }

    async getClinics() {
        this.setState({tableLoading: true}, async () => {
            try {
                let res = await api.get(this.getAPIUrl());

                let pagination = null;
                let clinics = [];
                const userType = this.props.userType;
                const tab = this.state.payload.status;
                if (res && res.data && res.data.success) {
                    clinics = res.data.data.data;
                    pagination = res.data.data.pagination;

                    _.forEach(clinics, (v, k) => {
                        v.chainbool = v.is_chain;
                        v.is_chain = v.is_chain ?
                            <div className={styles.purple} key={v.id}>
                                <Tooltip content={$t('global.clinics.chain')}><FaHospital/></Tooltip>
                            </div>
                            :
                            <div className={styles.blue} key={v.id}>
                                <Tooltip content={$t('global.clinics.clinic')}><FaClinicMedical/></Tooltip>
                            </div>

                        // v.id = <Link to={`/clinic/${v.id}`}><Tooltip
                        //     content={$t('global.clinics.viewClinic')}>{v.id}</Tooltip></Link>
                        v.name = <Link className='clinicLink' to={`/clinic/${v.id}`}><Tooltip
                            content={v.chainbool ? $t('global.clinics.viewChain') : $t('global.clinics.viewClinic')}>{v.name}</Tooltip></Link>
                        v.address = `${v.country ? v.country + ',' : ''} ${v.city ? v.city + ',' : ''} ${v.address ? v.address : ''}`;
                        // v.created_at = moment(v.created_at).format('LL');
                        v.created_at = <Timestamp time={v.created_at}/>

                        v.actionsComponent = userType === 5 ?
                            <div className="d-flex justify-content-center" style={{gap: '7px'}}>
                                <HasPermission permission="clinic.delete">
                                    {v.deleted_at ? 
                                        <Tooltip content={$t('global.clinics.restoreClinic')}>
                                        <RestoreDeletedClinic id={v.id}
                                                            clinicName={v.name}
                                                            style={{fontSize: '20px'}}
                                                            onSuccess={async () => await this.getClinics()}
                                        />
                                        </Tooltip>
                                        : 
                                        <Tooltip content={$t('global.clinics.deleteClinic')}>
                                                <DeleteClinic id={v.id}
                                                            clinicName={v.name}
                                                            style={{fontSize: '20px'}}
                                                            onSuccess={async () => await this.getClinics()}
                                                />
                                        </Tooltip>
                                    }      
                                </HasPermission>                          
                            </div> : null;
                        // v.treatment_saved_data = <Tooltip
                        //     content={this.state.treatment_saved_data[parseInt(v.treatment_saved_data) - 1].label}>{v.treatment_saved_data}</Tooltip>;

                        v.workingMode = <WorkingMode mode={v.treatment_saved_data}/>
                    })

                    this.setState({platforms: [], pagination: pagination}, () => {
                        this.setState({
                            clinics: [],
                            pagination: []
                        }, () => {
                            this.setState({
                                clinics: clinics,
                                pagination: pagination
                            })
                        });
                    })
                }
            } catch (e) {
                console.error('err get platforms:', e);
            } finally {
                this.setState({tableLoading: false});
            }
        });
    }

    dataTableActionHandler(data) {
        // console.log('dataTableActionHandler', data)
        if (data.key === 'page') {
            let payload = {...this.state.payload};
            payload.page = data.value;

            this.setState({payload: payload}, async () => {
                await this.getClinics();
            });
        } else if (data.key === 'header') {
            let payload = {...this.state.payload};

            if (payload.sort === data.value) {
                payload.order = payload.order === 'desc' ? 'asc' : 'desc'
            }
            payload.sort = data.value;

            this.setState({payload: payload}, async () => {
                await this.getClinics();
            });
        }
    }

    searchHandler(e) {
        let payload = {...this.state.payload};
        payload.search = e.target.value;
        payload.page = 1;

        this.setState({payload: payload}, async () => {
            await this.getClinics();
        });
    }

    changeMode(mode) {
        let state = {...this.state};
        state.mode = mode;
        state.payload.status = mode;
        state.payload.page = 1;
        this.setState(state, async () => {
            await this.getClinics();
        })
    }


    render() {
        let tableLoading = this.state.tableLoading;
        let clinics = this.state.clinics;
        let pagination = this.state.pagination;
        let tableSorted = {
            id: this.state.payload.sort,
            desc: this.state.payload.order === 'desc'
        }
        const modes = [
            "all",
            "active",
            "deleted"
        ];

        let tableHeaders = [
            (
                (this.props.userType && this.props.userType >= 4) ?
                    {
                        name: '',
                        id: 'is_chain',
                        clickable: true
                    } : null
            ),
            {
                name: this.props.userType && this.props.userType >= 4 ? $t('global.clinics.clinicChainName') : $t('global.clinics.clinicName'),
                id: 'name',
                clickable: true
            },
            {
                name: this.props.userType && this.props.userType >= 4 ? $t('global.clinics.clinicChainNumber') : $t('global.clinics.clinicNumber'),
                id: 'number',
                clickable: true
            },
            {
                name: $t('global.clinics.workingMode'),
                id: 'workingMode'
            },
            {
                name: $t('global.clinics.platforms'),
                id: 'platforms'
            },
            {
                name: $t('global.clinics.applicators'),
                id: 'applicators'
            },
            {
                name: $t('global.clinics.patients'),
                id: 'patients'
            },
            {
                name: $t('global.clinics.staff'),
                id: 'staff'
            },
            {
                name: $t('global.clinics.phoneNumber'),
                id: 'phone'
            },
            {
                name: $t('global.clinics.address'),
                id: 'address'
            },
            {
                name: $t('global.clinics.creationDate'),
                id: 'created_at',
                clickable: true
            },
            // {
            //     name: '',
            //     id: 'actionsComponent'
            // },
            (
                (this.props.userType && this.props.userType === 5) ?
                    {
                        name: '',
                        id: 'actionsComponent',
                        clickable: false
                    } : null
            ),
        ];

        return (
            <div id='clinicsTable' className={'container'}>
                <div className={'box'}>
                    <div className={'alma-box'}>
                        <div className={'alma-box-header'}>
                            <div><h3 id="clinicsTableTitle">{this.props.header}</h3></div>
                        </div>
                        {this.props.userType === 5 ?
                            <div className={Style['patients-menu']} style={{padding: '0 20px'}}>
                                {modes.map((mode, index) => {
                                    const modeText = $t(`global.clinics.modes.${mode}`);
                                    return (
                                        <a key={index}
                                           className={mode === this.state.payload.status ? styles["active-link"] : ""}
                                           href="#" onClick={(e) => {
                                            e.preventDefault();
                                            this.changeMode(mode)
                                        }}>{modeText}</a>
                                    )
                                })}
                            </div>
                            :
                            null
                        }
                        <div className={'alma-fields-row'}>
                            <div className={'alma-field-container'}>
                                <div className={'alma-field-header'}>{$t('global.clinics.search')}</div>
                                <Input name="search"
                                       autoComplete={false}
                                    // disabled={tableLoading}
                                       delay={500}
                                       className={`${'alma-input'}`}
                                       type="text"
                                       value={this.state.payload.search}
                                       placeholder={$t('global.clinics.searchByNameNumberOrId')}
                                       onChange={(e) => this.searchHandler(e)}/>
                            </div>
                            <div className={'alma-field-container'}>
                                <div className={'alma-field-header'}>Show Clinic/Chain</div>
                                <MultiSelect
                                    searchable
                                    options={this.state.typeOptions}
                                    placeholder={"Select Clinic/Chain"}
                                    onValueChange={(data) => {
                                        this.setState({
                                            payload: {...this.state.payload, type: data.value, page: 1},
                                        }, async () => {
                                            await this.getClinics();
                                        });
                                    }}
                                    selected={{
                                        label: this.state.typeOptions.find(item => item.value === this.state.payload.type)?.label,
                                        value: this.state.payload.type
                                    }}
                                />
                            </div>
                        </div>
                        <div>
                            <DataTable data={clinics}
                                       headers={tableHeaders}
                                       pagination={pagination}
                                       loading={tableLoading}
                                       sorted={tableSorted}
                                       apiUrl={this.getAPIUrl()}
                                       onAction={(e) => this.dataTableActionHandler(e)}
                            />
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}


export default ClinicsTable;

